export enum FileSaverUsecase {
  CSV_EXPORT_NETZBETREIBER,
}
